import React, { useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useAuth } from '../auth/AuthContext';

export default function Login() {
  const { user, login, loading, error: connectionError, refresh } = useAuth();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const from = location.state && location.state.from;
  const destination = from && from.pathname && from.pathname.startsWith('/') && !from.pathname.startsWith('//') && from.pathname !== '/login' ? from : '/profile';
  if (user) return <Redirect to={destination} />;
  async function submit(event) {
    event.preventDefault(); setBusy(true); setError('');
    try { await login(username, password); }
    catch (err) { if (mounted.current) { setError(err.message); setPassword(''); } }
    finally { if (mounted.current) setBusy(false); }
  }
  return <main className="account-page">
    <h1>Log in</h1>
    <p>Accounts are created by an administrator. Contact a site administrator to request access.</p>
    {connectionError && <p role="alert">{connectionError} <button onClick={() => refresh().catch(() => {})}>Retry</button></p>}
    {error && <p role="alert">{error}</p>}
    <form className="account-form" onSubmit={submit}>
      <label>Username<input autoComplete="username" required maxLength={64} value={username} onChange={e => setUsername(e.target.value)} /></label>
      <label>Password<input type="password" autoComplete="current-password" required maxLength={128} value={password} onChange={e => setPassword(e.target.value)} /></label>
      <button disabled={busy || loading || !!connectionError}>{busy ? 'Logging in…' : 'Log in'}</button>
    </form>
  </main>;
}
